import { render } from "./VideoCard.vue?vue&type=template&id=686d52b4&scoped=true&ts=true"
import script from "./VideoCard.vue?vue&type=script&lang=ts"
export * from "./VideoCard.vue?vue&type=script&lang=ts"

import "./VideoCard.vue?vue&type=style&index=0&id=686d52b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686d52b4"]])

export default __exports__